// extracted by mini-css-extract-plugin
export default {"privacy":"PrivacyPolicy_privacy__+l1gz","container":"PrivacyPolicy_container__YQU9G"};